class ucgVideo extends HTMLElement {
  constructor() {
    super()
    this.clickAndDrag('.ugc-slide-wrapper');
    this.discriptionToggle();
    this.initSlide();
    this.closePopup();
    this.qntChange();
    this.variantChange();
    this.toggleSound();
    this.pdpOptMobile();
    this.handleAtc();
  }

  initSlide() {
    var swiper = new Swiper('.ugc-wrapper .ugc-pop-slider .swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      loop: true,
      observer: true,
      direction: "horizontal",
      observeParents: true,
      navigation: {
        nextEl: ".ugc-wrapper .swiper-button-next",
        prevEl: ".ugc-wrapper .swiper-button-prev",
      },
      breakpoints: {
        768: {
          direction: 'horizontal',
          slidesPerView: 2,
          spaceBetween: 50,
          loop: true,
          navigation: {
            nextEl: ".swiper-nagivations .swiper-button-next",
            prevEl: ".swiper-nagivations .swiper-button-prev",
          }
        }
      },
      on: {
        click() {
          swiper.slideTo(this.clickedIndex);
        }
      }
    })
    
    this.playActiveVideo(swiper); 
    this.onClickSlidePopup(swiper);
  }

  playActiveVideo(swiper) {
    swiper.on('slideChange', (e) => {
      let videos = this.querySelectorAll('.ugc-pop-slider video');
      videos.forEach(video => {
        video.pause()
      });
      setTimeout(() => {
        this.querySelector('.ugc-pop-slide-wrapper.swiper-slide.swiper-slide-active video')?.play();
      
      }, 100);
      setTimeout(() => {
        this.querySelector('.ugc-pop-slide-wrapper.swiper-slide.swiper-slide-prev video')?.play();
      }, 100);
      setTimeout(() => {
        this.querySelector('.ugc-pop-slide-wrapper.swiper-slide.swiper-slide-next video')?.play();
      }, 100);
    });
  }

  clickAndDrag(selector, scroll_speed = 2, classOnEvent = 'grabbed_elem') {
    const sliders = document.querySelectorAll(selector);
    let isDown = false;
    let startX;
    let scrollLeft;
    sliders.forEach(slider => {
      slider.addEventListener('mousedown', (e) => {
          e.preventDefault();
          isDown = true;
          slider.classList.add(classOnEvent);
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
      
          // prevent default child behavior
          document.body.addEventListener('click', function( event ){
              if (slider.contains(event.target)) {
                  event.preventDefault();
              }
          });
      });
      slider.addEventListener('mouseleave', () => {
          isDown = false;
          slider.classList.remove(classOnEvent);
      });
      slider.addEventListener('mouseup', () => {
          isDown = false;
          slider.classList.remove(classOnEvent);
      });
      slider.addEventListener('mousemove', (e) => {
          if(!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * scroll_speed; //scroll-fast
          slider.scrollLeft = scrollLeft - walk;
      });
    });
  }

  discriptionToggle() {
    let readMoreBtns = this.querySelectorAll('.ugc-wrapper a.read-more');
    readMoreBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.closest('.p-descriotion').querySelector('.desc-data').classList.toggle('open');
        e.currentTarget.textContent == 'Read More' ? e.currentTarget.textContent = 'Read Less' : e.currentTarget.textContent = 'Read More';
      })
    });
  }

  onClickSlidePopup(swiper) {
    let slides = this.querySelectorAll('.ugc-slide-wrapper .card-wrapper');
    slides.forEach(slide => {
      slide.addEventListener('click', (e) => {
        document.body.style.overflow = 'hidden';
        let curr_slide = parseInt(e.currentTarget.dataset.index);
        swiper.realIndex = curr_slide;
        document.querySelector('.ugc-wrapper .ugc-pop-slider').classList.remove('is_hidden');
        document.querySelector('body').classList.add('shoppable-pop-up');
      })
    })
  }

  closePopup() {
    let popEle = this.querySelector('.popClose');
    popEle.addEventListener('click' , (e) => {
      e.currentTarget.closest('.ugc-pop-slider').classList.add('is_hidden');
      document.querySelector('body').classList.remove('shoppable-pop-up');
      let popEle = this.querySelectorAll('.ugc-pop-slide-wrapper .content-wrapper');
      document.body.style.overflow = null;
      popEle.forEach(ele => {
        ele.classList.remove('active')
      });
    })
    let mobileOverlay = this.querySelectorAll('.content-wrapper .overlay');
    mobileOverlay.forEach(ele => {
      ele.addEventListener('click', (e) => {
        e.currentTarget.closest('.content-wrapper').classList.remove('active')
      })
    })
  }

  variantChange() {
    let variantRadios = this.querySelectorAll('.var-input');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        let that = e.currentTarget;
        console.log("that",that)
        that.closest('.variant-radio-wrapper').querySelector('[type="hidden"]').value = that.value;
        console.log("e.currentTarget.closest('.content-body')",e.currentTarget)
        let productJson = JSON.parse(e.currentTarget.closest('.content-body')?.querySelector('[data-product-json]').textContent);
        let varJson = productJson.variants;
        let valOption1 = that.closest('.content-body').querySelector('input[name="position_1"]');
        let valOption2 = that.closest('.content-body').querySelector('input[name="position_2"]');
        let valOption3 = that.closest('.content-body').querySelector('input[name="position_3"]');
        let atcBtn = that.closest('form').querySelector('[data-atc]');
        let currVarJSON =  varJson.filter(item => {
          if (item?.option1 == valOption1?.value && item?.option2 == valOption2?.value && item?.option3 == valOption3?.value  ) {
            return item;
          }
        });
        currVarJSON = currVarJSON[0];
        that.closest('.content-body').querySelector('[name="id"]').value = currVarJSON.id;
        if (currVarJSON.available) {
          atcBtn.textContent = 'Add to cart';
          atcBtn.removeAttribute('disabled');
        } else {
          atcBtn.textContent = 'Sold out';
          atcBtn.setAttribute('disabled','');
        }

      })
    });
  }

  qntChange() {
    let incBtn = this.querySelectorAll('.qnt-wrapper .inc');
    let decBtn = this.querySelectorAll('.qnt-wrapper .dec');
    incBtn.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let qntInput = e.currentTarget.closest('.qnt-wrapper').querySelector('[name="quantity"]');
        qntInput.value = parseInt(qntInput.value) + 1;
      })
    })
    decBtn.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let qntInput = e.currentTarget.closest('.qnt-wrapper').querySelector('[name="quantity"]');
        if(qntInput.value > 1) qntInput.value = parseInt(qntInput.value) - 1;
      })
    })
  }

  toggleSound() {
    let toggleBtn = this.querySelectorAll('.ugc-wrapper .ugc-pop-slide-wrapper .volume-handle');
    toggleBtn.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let video = e.currentTarget.closest('.video-wrapper').querySelector('video');
        video.muted = !video.muted;
        e.currentTarget.classList.toggle('unmuted')
      })
    })
  }

  pdpOptMobile() {
    let trigger = this.querySelectorAll('.action-wrapper [popup-trigger]');
    trigger.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let that = e.currentTarget;
        e.preventDefault();
        that.closest('.ugc-pop-slide-wrapper').querySelector('.content-wrapper').classList.toggle('active');
        that.closest('.ugc-pop-slide-wrapper').querySelector('.content-wrapper a').focus();
      })
    })
  }

  handleAtc() {
    let atcBtns = this.querySelectorAll('[data-atc]');
    atcBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        let that = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();
        let qnt = that.closest('form').querySelector('[name="quantity"]').value;
        let id = that.closest('form').querySelector('[name="id"]').value;
        let bodyData = {"quantity": qnt,"id":id}
        that.setAttribute('disabled','');
        fetch('/cart/add',{method:'POST', headers: {'Accept': 'application/javascript','X-Requested-With': 'XMLHttpRequest','Content-Type': 'application/json'},body: JSON.stringify(bodyData)})
        .then(res => res.json())
        .then(res => {
          that.removeAttribute('disabled');
          let successMsg;
          if (res.status == 422) {
            successMsg = `<div class="atc-sucess">${res.description}</div>`;
          } else {
            successMsg = `<div class="atc-sucess">Product added to cart</div>`;
          }
          that.insertAdjacentHTML("afterend", successMsg);
          setTimeout(() => {
            that.nextSibling.remove();  
          }, 2000);
        })
        .catch(err => console.log(err))
      })
    });
  }
}

customElements.define('ucg-video',ucgVideo);
